import React from 'react';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Render from '../../common/Render';
import ListItem from './ListItem';
import { requestDataIfNeeded as requestUserGoals } from './duck';

class Memos extends React.Component {
  componentDidMount() {
    const { requestUserGoals, user } = this.props;

    requestUserGoals({ user: user._id });
  }

  renderAfterLoading = () => {
    const { memos, goal, currentUserId } = this.props;
    const goalMemos = memos.filter((m) => m.goal === goal._id);

    if (_.isEmpty(goalMemos)) {
      return null;
    }

    return (
      <div className="o-layout u-1/1">
        <div className="o-layout__item u-1/1">
          {goalMemos.map((memo) => (
            <ListItem
              key={memo._id}
              memo={memo}
              goal={goal}
              currentUserId={currentUserId}
              isCurrentlyLoggedInUserMemo={memo.user._id === currentUserId}
            />
          ))}
        </div>
      </div>
    );
  };

  render() {
    const { isLoading, error } = this.props;

    return (
      <Render
        isLoading={isLoading}
        error={error}
        render={this.renderAfterLoading}
      />
    );
  }
}

const mapDispatchToProps = { requestUserGoals };

const mapStateToProps = ({ userGoalsMemos, user }) => ({
  isLoading: userGoalsMemos.isLoading,
  error: userGoalsMemos.error,
  memos: userGoalsMemos.data,
  currentUserId: user.data && user.data._id,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(Memos));



// WEBPACK FOOTER //
// ./src/goals/memos/List.js